import axios from 'axios';

export const getAllDepots = async (workspaceUuid) =>
  axios.get('/depots/', {
    params: { ...(workspaceUuid ? { workspace_uuid: workspaceUuid } : {}) },
  });
